import { render, staticRenderFns } from "./InscricaoEstadual.vue?vue&type=template&id=83b2d10e"
import script from "./InscricaoEstadual.vue?vue&type=script&lang=js"
export * from "./InscricaoEstadual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports